// extracted by mini-css-extract-plugin
export default {"userContainer":"User_userContainer__vR-dI","imgAndNameContainer":"User_imgAndNameContainer__ZUkFx","contentContainer":"User_contentContainer__QXD03"};